import { useMutation } from "@apollo/client/react";import { useState } from "react";

import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import UPDATE_HONORARIOS_PROFESIONAL from "../../../../../data/graphQL/mutations/GestionAsistencial/updateHonorarioProfesional";
import toast from 'react-hot-toast';
import adaptEvaluacionProfesionalGrillaArray from "../../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalGrilla";
import adaptEvaluacionProfesionalReemplazoGrillaArray from "../../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalReemplazoGrilla";

export function TabProfesionalUpdateHonorariosDialog({
  open,
  handleCloseDialog,
  refetchEvaluacionProfesional,
  setEvaluacionProfesional,
  evaluacionProfesionalIds,
  refetchReemplazos,
  setEvaluacionProfesionalReemplazo
}) {
  const [loading, setLoading] = useState(false);

  const [updateEvaluacionProfesional] = useMutation(UPDATE_HONORARIOS_PROFESIONAL, {
    onCompleted: () => {
      toast.success("Honorarios actualizados con éxito.");
      refetchEvaluacionProfesional().then(({ data }) => {
        setEvaluacionProfesional(adaptEvaluacionProfesionalGrillaArray(data));
      });
      refetchReemplazos().then(({ data }) => {
        setEvaluacionProfesionalReemplazo(adaptEvaluacionProfesionalReemplazoGrillaArray(data));
      });
      setLoading(false);
      handleCloseDialog();
    },
    onError: () => {
      toast.error("Error al actualizar honorarios.");
      setLoading(false);
    }
  });

  const handleAcceptUpdate = () => {
    setLoading(true);
    updateEvaluacionProfesional({
      variables: { idsEvaluacionProfesional: evaluacionProfesionalIds }
    });
  };

  return (
    <CustomDialog
      title="Actualizar honorarios"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      onAccept={handleAcceptUpdate}
      cancelText="Cancelar"
      acceptText="Actualizar"
      acceptLoading={loading}
      acceptDisabled={loading}>
      
      ¿Usted esta seguro/a que desea actualizar el valor de los honorarios de cada uno de
      los profesionales al valor actual?
    </CustomDialog>);

}